import { render, staticRenderFns } from "./CreateProductBtn.vue?vue&type=template&id=1ced6b88"
import script from "./CreateProductBtn.vue?vue&type=script&lang=ts"
export * from "./CreateProductBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports